import { render, staticRenderFns } from "./ExclusiveOffersConsole.vue?vue&type=template&id=a0851088&scoped=true&"
import script from "./ExclusiveOffersConsole.vue?vue&type=script&lang=js&"
export * from "./ExclusiveOffersConsole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0851088",
  null
  
)

export default component.exports